// extracted by mini-css-extract-plugin
export default {"modal":"Aba-z","modalContent":"Bba-z","footer":"Cba-z","cancelBtn":"Dba-z","disabled":"Eba-z","formWrapper":"Fba-z","fade":"Gba-z","fade-in":"Hba-z","iframe":"Iba-z"};